import React, { useContext } from 'react';

import { Anchor, Heading, Icon, List } from '@zillow/constellation-10';
import { IconHouseFilled } from '@zillow/constellation-icons';

import { RMWContext } from '../../../../providers/RMWContext';

const Congratulations = ({
  convertedListingAlias,
  handleModalReset,
}: {
  convertedListingAlias: string;
  handleModalReset: () => void;
}) => {
  const { paths } = useContext(RMWContext);

  const pathToRoute = `${paths.propertiesPage}/${convertedListingAlias}/listing`;

  const handleNewTab = () => {
    window.router.updateLocation(pathToRoute, '_blank');
  };

  return (
    <>
      <Icon render={<IconHouseFilled />} css={{ marginBottom: '600' }} />
      <Heading level={4} fontFamily="heading-alt" css={{ marginBottom: '400' }}>
        Congratulations!
      </Heading>
      <List.Root>
        <List.Item>
          <Anchor onClick={handleNewTab}>View your converted listing</Anchor>
        </List.Item>
        <List.Item>
          <Anchor onClick={handleModalReset}>Convert another floor plan/unit</Anchor>
        </List.Item>
      </List.Root>
    </>
  );
};

export default Congratulations;
